import React from 'react'
import ServicePricing from './ServicePricing'

function PricePackPremiumSch() {
  return (
    <>
      <div className='pricing-features'>
        <ServicePricing
          btn='Premium web design'
          panelText='A premium web layout, custom built to control your information and branding with emphasis place on making you more reputable and trustworthy online.'
        />
        <ServicePricing
          btn='Mobile Responsiveness'
          panelText='Your website will be optimized to look and perform well on all devices. Devices include but are not limited to Smart Phones, Tablets, Laptops, Televisions etc.'
        />
        <ServicePricing
          btn='20 web pages'
          panelText='This package comes with 20 web pages. Additional pages come with small a fee.'
        />
        <ServicePricing
          btn='Social Media Integration'
          panelText='Your users will be able to access your various social media accounts from your website.'
        />
        <ServicePricing
          btn='Social Sharing Integration'
          panelText='Engage your users by allowing them to share your website on social media platforms with one click.'
        />
        <ServicePricing
          btn='Google Maps Integration'
          panelText={`We collaborate with Google to include an interactive map with your school's location on your website.`}
        />
        <ServicePricing
          btn='Contact System Integration'
          panelText='Includes a contact system which allow users to get in touch from your website.'
        />
        <ServicePricing
          btn='Website Downloads'
          panelText='Engage your users by allowing them to download selected materials from your website.'
        />
        <ServicePricing
          btn='Online School Fee Payment'
          panelText={
            <>
              Applicable to Jamaica: <br /> Allow school fees to be paid online by any credit or international debit card. Payments will be deposited in school's Jamaican bank account.
            </>
          }
        />
      </div>
    </>
  )
}

export default PricePackPremiumSch
